<template>
  <div class="chat-messages">
    <preview-zoom-dialog
      :dialogType="dialogType"
      :imageSrc="imageSrc || currentFileSrc"
      :dialogFile="dialogFile"
      :dialogFileMlUrl="dialogFileMlUrl"
      :name="imageName"
      @close-dialog="closeMediaDialog"
      :messageText="messageText"
      :sending-message="sendingMessage"
      @add-message="addMessage"
      @change-message="changeMessage"
      @reload-resource="reloadResource"
    />
    <div class="chat-messages__wrap">
      <div ref="chat-window" class="chat-messages-window pt-2">
        <div ref="messages-content">
        <v-btn
          v-if="
            messagesLength >= historyMessagesCounter &&
              currentChat &&
              !hasFullHistory
          "
          class="mb-2"
          color="accent"
          elevation="0"
          block
          small
          outlined
          @click="getMoreMessages"
        >
          Load more
        </v-btn>
        <div v-if="messagesLength === 0" class="chat-messages-empty">
          <section v-if="directChannel">
            <v-img
              class="chat-messages-empty-image"
              alt="Empty chat image"
              src="@/assets/emptyChat.svg"
              contain
              height="310"
              width="390"
            />
            <h3 class="chat-messages-empty-text text-center">
              Write a message to start conversation
            </h3>
          </section>
          <section v-else>
            <v-img
              class="chat-messages-empty-image"
              alt="Empty chat image"
              src="@/assets/emptyChat.svg"
              contain
              height="310"
              width="390"
            />
            <h3 class="chat-messages-empty-text text-center">
              It’s nice to chat with someone
            </h3>
            <p
              class="chat-messages-empty-text chat-messages-empty-text--subtitile text-center"
            >
              {{ emptyChatMessage }}
            </p>
          </section>
        </div>
        <chat-message
          v-else
          v-for="(msg, index) in messages"
          :channelId="msg.channel"
          :selected="
            getMessageKey(msg, index) === getMessageKey(selectedMessage, index)
          "
          :key="getMessageKey(msg, index)"
          :message="msg.message"
          :lng="msg.lng"
          :file="msg.file || null"
          :date="msg.timetoken"
          :current-user="currentUser"
          :reactions="reactions"
          :chat-users="chatUsers"
          :get-file-url="getFileUrl"
          :media-library-files="(msg.message || {}).mediaLibraryFiles || null"
          :static-media-id="(msg.message || {}).staticMediaId || null"
          :get-message-by-timetoken="getMessageByTimetoken"
          :get-resource-by-url="getResourceByUrl"
          :parse-output-message-text="parseOutputMessageText"
          :get-resource-by-id="getResourceById"
          :send-existing-resource="sendExistingResource"
          :is-role-allowed="isRoleAllowed"
          :direct-chat="directChat"
          @setSelectedMessage="
            setSelectedMessage(msg, $event.text, $event.method)
          "
          @reactionClicked="reactionClicked($event.type, msg)"
          @removeMessage="removeMessage(msg)"
          @ackMessage="ackMessage(msg)"
          @copyMessage="copyMessage((msg.message || {}).text)"
          @askAi="askAi((msg.message || {}).text, $event)"
          @showBiggerImage="showBiggerImage"
          @downloadFile="$emit('downloadFile', $event)"
          @downloadResourceByUrl="downloadResourceByUrlHandler"
        />
        </div>
      </div>
      <!-- <div class="chat-messages-footer px-6">
        <chat-message-footer
          v-if="currentChat"
          :current-user-is-writing="currentUserIsWriting"
          :current-chat="currentChat"
          :active-writers="activeWriters"
          :quick-messages="quickMessages"
        />
      </div> -->

      <!-- v-if to remove after moving to dedicated component -->
      <div class="chat-messages-footer px-6" v-if="userCanSendMessage">
        <v-row
          v-if="selectedMessage"
          no-gutters
          align="center"
          direction="column"
          class="chat-messages-footer__row chat-selected-message__wrap"
        >
          <div class="chat-selected-message">
            <strong v-if="selectedMessageMethod === 'EDIT'"
              >Edit message</strong
            >
            <strong v-if="selectedMessageMethod === 'REPLY'"
              >Reply to {{ getUserName(selectedMessage.uuid) }}</strong
            >
            <p>{{ selectedMessage.message.text }}</p>
            <v-btn
              @click="setSelectedMessage()"
              icon
              min-height="16"
              min-width="16"
              type="reverse"
              class="chat-selected-message__close"
              small
            >
              <v-icon color="bhBlack" size="12">bhi-close</v-icon>
            </v-btn>
          </div>
        </v-row>
        <v-row no-gutters align="center" class="chat-messages-footer__row">
          <v-btn
            icon
            color="accent"
            elevation="0"
            :disabled="!userCanSendMessage || quickMessages.length === 0"
            @mousedown="showQuickMessagesHandler"
          >
            <v-icon>bhi-message</v-icon>
          </v-btn>
          <v-btn
            v-if="isRoleAllowed && directChat"
            icon
            color="accent"
            elevation="0"
            @click="$emit('askAi', '', recipientUser.profileId)"
          >
            <v-icon>bhi-ask-hs</v-icon>
          </v-btn>
          <div class="chat-messages-footer-body-wrapper">
            <div class="chat-messages-footer-body">
              <v-textarea
                v-model="messageText"
                class="chat-messages-footer-input rounded-pill"
                ref="textField"
                rows="1"
                elevation="0"
                no-resize
                autofocus
                hide-details
                solo
                flat
                dense
                filled
                @blur="onBlur"
                @input="onInput"
                @keydown.enter.exact.prevent="addMessage"
              >
                <template v-slot:prepend-inner>
                  <v-btn
                    icon
                    color="accent"
                    elevation="0"
                    @mousedown="openStickersPickerDialog"
                  >
                    <v-icon color="accent"> mdi-emoticon-outline </v-icon>
                  </v-btn>
                </template>
              </v-textarea>
              <v-btn
                v-if="enabledAckButton"
                height="32"
                rounded
                elevation="0"
                color="accent"
                :outlined="!needAck"
                @click="needAck = !needAck"
              >
                <v-icon left size="18">
                  {{ `mdi-check-circle${needAck ? '' : '-outline'}` }}
                </v-icon>
                Confirm Receive
              </v-btn>
              <!-- post-action="/upload/post" -->
              <v-btn
                v-if="enabledGifButton"
                icon
                elevation="0"
                color="accent"
                class="upload-library-file ml-2"
                v-ripple="false"
                @click="openGifPickerDialog"
              >
                <v-icon size="28">mdi-file-gif-box</v-icon>
              </v-btn>
              <v-btn
                v-if="enabledMediaLibraryButton"
                icon
                elevation="0"
                color="accent"
                class="upload-library-file"
                v-ripple="false"
                @click="openMlFilePickerDialog"
              >
                <v-icon size="16">bhi-book-open</v-icon>
              </v-btn>
              <file-upload
                v-if="enabledUploadButton"
                class="upload-file-area mr-2"
                :multiple="false"
                :drop="true"
                :drop-directory="false"
                @input-file="inputFile"
                v-model="files"
                :accept="getMimeTypes([18, 19, 20])"
                ref="upload"
              >
                <v-btn icon elevation="0" color="accent">
                  <v-icon size="16">bhi-image</v-icon>
                </v-btn>
              </file-upload>
            </div>
            <div
              class="chat-messages-footer-notification"
              v-if="activeWritersProfiles.length"
            >
              {{ activeWritersProfiles.join(', ') }}
              {{ activeWritersProfiles.length === 1 ? 'is' : 'are' }} typing...
            </div>
            <v-card
              class="chat-messages-footer-menu"
              v-else-if="showQuickMessages"
            >
              <div
                class="chat-messages-footer-menu-quick-message"
                v-for="msg in quickMessages"
                :key="msg.id"
                @mousedown="addQuickMessage($event, msg.message)"
              >
                {{ msg.message }}
              </div>
            </v-card>
          </div>
          <v-btn
            icon
            color="accent"
            elevation="0"
            class="chat-messages-footer-send-button"
            :loading="sendingMessage"
            :disabled="!messageText && !currentFile"
            @click="addMessage"
          >
            <v-icon size="20">bhi-arrow-up</v-icon>
          </v-btn>
        </v-row>
      </div>
      <div v-else class="chat-messages-footer px-6"></div>
    </div>
    <gif-picker-dialog
      :show-dialog="showGifPickerDialog"
      @close-dialog="closeGifPickerDialog"
      @gif-picked="chosenGifPickerDialog"
    />
    <stickers-picker-dialog
      :show-dialog="showStickersPickerDialog"
      @close-dialog="closeStickersPickerDialog"
      @sticker-picked="chosenStickerPickerDialog"
    />
    <ml-file-picker-dialog
      :resources-receiver-ids="getReceiversIds"
      :show-dialog="showMlFilePickerDialog"
      @close-dialog="closeMlFilePickerDialog"
      @file-picked="chosenFileMlFilePickerDialog"
      @show-bigger-image="showBiggerImage"
    />
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import { debounce } from '@/helpers/debounce'
import ReactionsMixin from '@/mixins/reactions'
import ChatMessage from './components/ChatMessage'
import MlFilePickerDialog from '@/components/dialogs/MlFilePickerDialog.vue'
// import ChatMessageFooter from "./components/ChatMessageFooter"
import GifPickerDialog from '../dialogs/GifPickerDialog.vue'
import StickersPickerDialog from '../dialogs/StickersPickerDialog.vue'
import PreviewZoomDialog from '@/components/dialogs/PreviewZoomDialog.vue'
import { getFileTypeByName } from '@/helpers/chat'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { FILE_SIZE_LIMIT, FILE_SIZE_LIMIT_NAME } from '@/helpers/constants'
import { getDisplayName } from '@/helpers/getDisplayName'
const DEBOUNCE_TIMEOUT = 5000
let currentUserIsWriting = false

export default {
  name: 'ChatMessages',
  components: {
    ChatMessage,
    FileUpload,
    MlFilePickerDialog,
    GifPickerDialog,
    StickersPickerDialog,
    PreviewZoomDialog,
    // ChatMessageFooter
  },
  mixins: [ReactionsMixin],
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: [String, Number],
      default: '',
    },
    currentUser: {
      type: String,
      default: '',
    },
    activeWriters: {
      type: Array,
      default: () => ({}),
    },
    parseInputMessageText: {
      type: Function,
      default: e => e,
    },
    parseOutputMessageText: {
      type: Function,
      default: e => e,
    },
    emoji: {
      type: Array,
      default: () => [],
    },
    chatUsers: {
      type: Array,
      default: () => [],
    },
    chatsCounter: {
      type: Number,
      default: 0,
    },
    quickMessages: {
      type: Array,
      default: () => [],
    },
    getMessageByTimetoken: {
      type: Function,
      default: () => null,
    },
    getFileUrl: {
      type: Function,
      default: () => '',
    },
    directChannel: {
      type: Boolean,
      default: false,
    },
    hasFullHistory: {
      type: Boolean,
      default: false,
    },
    historyMessagesCounter: {
      type: Number,
      default: 0,
    },
    channelInitialized: {
      type: Boolean,
      default: false,
    },
    getResourceByUrl: {
      type: Function,
      default: () => null,
    },
    getResourceById: {
      type: Function,
      default: () => null,
    },
    sendExistingResource: {
      type: Function,
      default: () => null,
    },
    sendResource: {
      type: Function,
      default: () => null,
    },
    getMimeTypes: {
      type: Function,
      default: () => null,
    },
    enabledAckButton: {
      type: Boolean,
      default: true,
    },
    enabledGifButton: {
      type: Boolean,
      default: true,
    },
    enabledMediaLibraryButton: {
      type: Boolean,
      default: true,
    },
    enabledUploadButton: {
      type: Boolean,
      default: true,
    },
    directChat: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedMessageMethod: 'EDIT', // EDIT / REPLY
      selectedMessage: null,
      messageText: '',
      draftDirty: false,
      showQuickMessages: false,
      needAck: false,
      dateToday: new Date(Date.now()),
      files: [],
      currentFile: null,
      dialogType: 0,
      resourceId: null,
      imageSrc: false,
      imageName: false,
      dialogFile: null,
      dialogFileMlUrl: null,
      showMlFilePickerDialog: false,
      showGifPickerDialog: false,
      showStickersPickerDialog: false,
      sendingMessage: false,
      stickToBottom: true,
      resizeObserver: null,
    }
  },
  mounted() {
    const chatWindow = this.$refs['chat-window']
    const content = this.$refs['messages-content']
    if (!chatWindow) return

    chatWindow.addEventListener('scroll', this.onChatScroll, { passive: true })

    if (typeof ResizeObserver !== 'undefined' && content) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.stickToBottom) {
          requestAnimationFrame(() => this.pinToBottom())
        }
      })
      this.resizeObserver.observe(content)
    }
  },
  beforeDestroy() {
    this.flushChatDraft(this.currentChat)
    const chatWindow = this.$refs['chat-window']
    if (chatWindow) {
      chatWindow.removeEventListener('scroll', this.onChatScroll)
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  watch: {
    currentChat(value, oldValue) {
      // flush any pending draft for the chat we are leaving before resetting
      this.flushChatDraft(oldValue)

      if (value) {
        this.stickToBottom = true
        if (this.channelInitialized) {
          this.$emit('markMessagesAsRead')
        }
        this.scrollToBottom()

        setTimeout(() => {
          this.scrollToBottom()
        }, 500)
      }

      // reset messageText and selecting message when change chat channel
      this.messageText = ''
      this.selectedMessage = null

      if (value) {
        this.getChatMessageDraft({ chatId: value }).then(draft => {
          // ignore stale response if the user switched chat meanwhile
          if (this.currentChat !== value) return
          this.messageText = draft?.message || ''
        })
      }
    },
    messages(current, previous) {
      const currentLength = current.length
      const prevLength = previous.length

      if (
        this.currentChat &&
        prevLength !== 0 &&
        currentLength !== 0 &&
        currentLength !== prevLength &&
        current[currentLength - 1].timetoken !==
          previous[prevLength - 1].timetoken
      ) {
        const checkIfUserAtBottom = true
        this.scrollToBottom(checkIfUserAtBottom)
      }
    },
    dialogType(value) {
      if (value === 0 && (this.currentFile || this.imageSrc)) {
        this.closeMediaDialog()
      }
    },
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    ...mapState('patientsStates', ['currentPatient']),
    ...mapState('dictionariesStates', [
      'dictionaryPracticeUserRole',
      'dictionaryBhUsersRoleIds',
    ]),
    ...mapGetters('userStates', ['getRolename']),
    emptyChatMessage() {
      return this.chatsCounter === 0
        ? 'Please start a new chat'
        : this.currentChat
        ? 'Start your conversation'
        : 'Pick a person from left and start your conversation'
    },
    currentFileSrc() {
      return this.currentFile && this.currentFile.file
        ? URL.createObjectURL(this.currentFile.file)
        : ''
    },
    userCanSendMessage() {
      return this.directChannel || this.currentChat
    },
    messagesLength() {
      return this.messages.length
    },
    getReceiversIds() {
      const receivers = (this.chatUsers || [])
        .filter(el => el.uuid !== this.currentUser && el.isActive)
        .map(el => el.uuid)
      const receiversProfileId = this.profilePreviews
        .filter(el => receivers.indexOf(el.uuid) >= 0)
        .map(el => el.profileId)

      // Filter to remove duplicated profile ids
      return receiversProfileId.filter(
        (value, index, self) => self.indexOf(value) === index,
      )
    },
    isRoleAllowed() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Advisor ||
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin ||
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Consultant
      )
    },
    senderUser() {
      return this.profilePreviews.find(el => el.uuid === this.currentUser)
    },
    recipientUser() {
      if (!this.currentChat) {
        return this.currentPatient
      }

      const user = this.chatUsers.find(el => el.uuid !== this.currentUser)
      return this.profilePreviews.find(el => el.uuid === user.uuid) || {}
    },
    activeWritersProfiles() {
      const freeChatMembers = this.chatUsers
        .filter(
          el =>
            el.uuid === this.activeWriters.indexOf(el.uuid) >= 0 &&
            el.isFreeUser,
        )
        .map(() => 'Free User')

      const activeWritersNames = this.profilePreviews
        .filter(el => this.activeWriters.indexOf(el.uuid) >= 0)
        .map(el =>
          getDisplayName(el?.fullName, el?.firstName, el?.lastName, el?.nick),
        )

      return [...freeChatMembers, ...activeWritersNames]
    },
  },
  methods: {
    ...mapActions('libraryStates', ['uploadFile']),
    ...mapActions('chatStates', [
      'getChatMessageDraft',
      'saveChatMessageDraft',
      'deleteChatMessageDraft',
    ]),
    ...mapMutations('appStates', ['setSnackbarNotification']),
    getUserFromChatUsers(uuid) {
      return this.chatUsers.find(user => user.uuid === uuid) || {}
    },
    getUserName(uuid) {
      return this.getUserFromChatUsers(uuid).fullName || uuid
    },
    setSelectedMessage(msg = null, messageText = '', method = 'EDIT') {
      // method: EDIT || REPLY
      this.selectedMessageMethod = method
      this.selectedMessage = msg
      this.messageText = messageText
      this.expandMessageInput()
    },
    getMessageKey(msg, index) {
      return `${msg?.timetoken || 0}-${msg?.message?.id || 0}-${
        msg?.uuid
      }-${index}`
    },
    downloadResourceByUrlHandler(resourceUrl) {
      this.$emit('downloadResourceByUrl', resourceUrl)
    },
    openGifPickerDialog() {
      this.showGifPickerDialog = true
    },
    closeGifPickerDialog() {
      this.showGifPickerDialog = false
    },
    chosenGifPickerDialog(gif) {
      this.showGifPickerDialog = false

      this.$emit('addMessage', {
        messageText: '',
        needAck: false,
        giphyFile: gif,
      })
    },
    openStickersPickerDialog() {
      this.showStickersPickerDialog = true
    },
    closeStickersPickerDialog() {
      this.showStickersPickerDialog = false
    },
    async chosenStickerPickerDialog(sticker) {
      this.showStickersPickerDialog = false

      const stickerFile = await fetch(sticker.uri)
      const stickerArrayBuffer = await stickerFile.arrayBuffer()

      this.$emit('addMessage', {
        messageText: '',
        needAck: false,
        file: {
          data: stickerArrayBuffer,
          name: sticker.name,
          mimeType: 'image/png',
        },
      })
    },
    openMlFilePickerDialog() {
      this.showMlFilePickerDialog = true
    },
    closeMlFilePickerDialog() {
      this.showMlFilePickerDialog = false
    },
    chosenFileMlFilePickerDialog(id, name) {
      this.getResourceById({ resourceId: id })
        .then(response => {
          const { data } = response
          let type = 2
          switch (data.fileTypeId) {
            case 18:
              type = 2
              break
            case 19:
              type = 4
              break
            case 20:
              type = 6
              break
            default:
              type = 2
              break
          }
          if (data.fileUrl) {
            this.resourceId = id
            this.imageSrc = data.fileUrl
            this.imageName = data.name
            this.dialogFileMlUrl = data.fileUrl
            this.dialogType = type
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    chosenFileMlFilePickerDialog2(id, name) {
      this.showMlFilePickerDialog = false

      const receiversProfileId = this.getReceiversIds

      this.sendExistingResource({
        resourceId: id,
        receiversIds: receiversProfileId,
      }).then(response => {
        this.$emit('addMessage', {
          messageText: this.messageText,
          needAck: false,
          mediaLibraryFiles: response.data,
        })
        this.messageText = ''
      })

      this.userStoppedWriting()
      this.$nextTick(() => {
        this.needAck = false
        this.currentFile = null
        this.dialogType = 0
      })
    },
    async addMessage() {
      if (
        this.sendingMessage ||
        (!this.messageText && !this.currentFile && !this.imageSrc)
      ) {
        return
      }

      this.sendingMessage = true

      if (this.selectedMessage && this.selectedMessageMethod === 'EDIT') {
        // Edit exists message
        this.$emit('addMessageAction', {
          message: this.selectedMessage,
          type: 'updated',
          value: this.messageText,
        })
      } else if (
        this.selectedMessage &&
        this.selectedMessageMethod === 'REPLY'
      ) {
        this.$emit('addMessage', {
          messageText: this.messageText,
          needAck: this.needAck,
          replyMessageTimetoken: this.selectedMessage.timetoken,
        })
      } else {
        // Add new message
        const file = this.currentFile ? this.currentFile.file : null
        let response

        const receiversProfileId = this.getReceiversIds

        if (file) {
          let storageFileId
          try {
            const fileResponse = await this.uploadFile({
              file,
            })
            storageFileId = fileResponse.data.id
          } catch (error) {
            console.error(error)
          }

          response = await this.sendResource({
            storageFileId,
            receiversIds: receiversProfileId,
          })
        } else if (this.resourceId) {
          response = await this.sendExistingResource({
            resourceId: this.resourceId,
            receiversIds: receiversProfileId,
          })
        }

        this.$emit('addMessage', {
          messageText: this.messageText,
          needAck: this.needAck,
          mediaLibraryFiles: response && response.data ? response.data : null,
        })
      }

      this.userStoppedWriting()
      this.$nextTick(() => {
        this.sendingMessage = false
        this.setSelectedMessage()
        this.messageText = ''
        this.needAck = false
        this.currentFile = null
        this.showMlFilePickerDialog = false
        this.dialogType = 0
        this.expandMessageInput(true)
      })
      setTimeout(() => {
        this.scrollToBottom()
      }, 500)

      // cancel any pending draft autosave and remove the stored draft
      debounce(null, 0, 'ChatDraft', 'cancel')
      this.deleteChatMessageDraft({ chatId: this.currentChat })
      this.draftDirty = false
    },
    changeMessage(message) {
      this.messageText = message
      this.expandMessageInput()
    },
    removeMessage(message) {
      this.$emit('removeMessage', message)
    },
    ackMessage(message) {
      this.$emit('ackMessage', message)
    },
    copyMessage(messageText) {
      this.$emit('copyMessage', messageText)
    },
    askAi(messageText, profileId) {
      if (profileId && messageText) {
        this.$emit('askAi', messageText, profileId)
      }
    },
    expandMessageInput(reset = false) {
      this.$nextTick(() => {
        const textField = this.$refs.textField.$refs.input
        if (reset) {
          textField.style.height = '20px'
        } else {
          textField.style.height = '5px'
          textField.style.height = textField.scrollHeight + 'px'
        }
      })
    },
    reactionClicked(value, message) {
      let userReaction = null
      const action = message.message.reactions.forEach(reaction => {
        if (reaction.type === value) {
          userReaction = reaction.users.find(
            user => user.user === this.currentUser,
          )
        }
      })

      if (userReaction) {
        this.$emit('removeMessageAction', userReaction)
      } else {
        this.$emit('addMessageAction', { message, type: 'reaction', value })
      }
    },
    pinToBottom() {
      const chatWindow = this.$refs['chat-window']
      if (chatWindow) {
        chatWindow.scrollTop = chatWindow.scrollHeight
      }
    },
    onChatScroll() {
      const chatWindow = this.$refs['chat-window']
      if (!chatWindow) return
      const THRESHOLD = 80
      const distanceFromBottom =
        chatWindow.scrollHeight - chatWindow.scrollTop - chatWindow.clientHeight
      this.stickToBottom = distanceFromBottom <= THRESHOLD
    },
    scrollToBottom(checkIfUserAtBottom = false) {
      this.$nextTick(() => {
        debounce(
          () => {
            // timeout due to messages generation
            const chatWindow = this.$refs['chat-window']
            const lastMessageHeight =
              chatWindow?.children?.[(chatWindow?.children?.length || 1) - 1]
                ?.clientHeight || 0

            // Offset which will be checked if user is on the bottom or bottom minus this offset, if not then do not scroll to bottom.
            // to offset is added last messages, because view is rerendered
            const OFFSET_FROM_BOTTOM = lastMessageHeight + 150

            if (checkIfUserAtBottom) {
              const currentBottomPosition =
                chatWindow.clientHeight + chatWindow.scrollTop
              const minRange = chatWindow.scrollHeight - OFFSET_FROM_BOTTOM
              const maxRange = chatWindow.scrollHeight

              if (
                currentBottomPosition >= minRange &&
                currentBottomPosition <= maxRange
              ) {
                chatWindow.scrollTo(0, chatWindow.scrollHeight)
              }
            } else {
              chatWindow.scrollTo(0, chatWindow.scrollHeight)
            }
          },
          100,
          'ChatMessages',
        )
      })
    },
    saveDraftMessage() {
      const chatId = this.currentChat
      if (!chatId) return
      if (this.messageText === '') {
        this.deleteChatMessageDraft({ chatId })
      } else {
        this.saveChatMessageDraft({ chatId, message: this.messageText })
      }
      this.draftDirty = false
    },
    flushChatDraft(chatId) {
      if (!chatId || !this.draftDirty) return
      // cancel the pending autosave and persist immediately
      debounce(null, 0, 'ChatDraft', 'cancel')
      if (this.messageText === '') {
        this.deleteChatMessageDraft({ chatId })
      } else {
        this.saveChatMessageDraft({ chatId, message: this.messageText })
      }
      this.draftDirty = false
    },
    onInput(value) {
      const parsedText = this.parseInputMessageText(value)
      const textField = this.$refs.textField.$refs.input

      if (parsedText.modified) {
        const cursorPosition = textField.selectionStart

        this.setCursorPosition(cursorPosition)
      }

      this.messageText = parsedText.text
      this.showQuickMessages = false
      this.userIsWriting()
      this.expandMessageInput()
      this.draftDirty = true
      debounce(() => this.saveDraftMessage(), 2000, 'ChatDraft')
    },
    onBlur(e) {
      this.showQuickMessages = false

      if (currentUserIsWriting) {
        currentUserIsWriting = false
        debounce(() => this.userStoppedWriting(), 0, 'ChatMessages')
      }
    },
    userStoppedWriting() {
      this.$emit('sendWritingSignal', {
        channel: this.currentChat,
        type: 'typing_off',
      })
      currentUserIsWriting = false
    },
    userIsWriting() {
      if (!currentUserIsWriting) {
        this.$emit('sendWritingSignal', {
          channel: this.currentChat,
          type: 'typing_on',
        })
        currentUserIsWriting = true
      }

      debounce(
        () => this.userStoppedWriting(),
        DEBOUNCE_TIMEOUT,
        'ChatMessages',
      )
    },
    addEmoji(e, emoji) {
      e.preventDefault()
      const textField = this.$refs.textField.$refs.input
      const cursorPosition = textField.selectionStart
      const len = this.messageText.length
      const before = this.messageText.substr(0, cursorPosition)
      const after = this.messageText.substr(cursorPosition, len)

      this.messageText = before + emoji + after
      this.setCursorPosition(cursorPosition + emoji.length)
      this.draftDirty = true
      debounce(() => this.saveDraftMessage(), 2000, 'ChatDraft')
    },
    addQuickMessage(e, message) {
      e.preventDefault()

      this.messageText = message
      this.userIsWriting()
    },
    showQuickMessagesHandler(e) {
      e.preventDefault()
      this.showQuickMessages = !this.showQuickMessages
      this.$refs.textField.$refs.input.focus()
    },
    setCursorPosition(pos) {
      this.$nextTick().then(() => {
        this.$refs.textField.$refs.input.selectionStart = pos
        this.$refs.textField.$refs.input.selectionEnd = pos
      })
    },
    inputFile(newFile, oldFile) {
      if (!newFile) {
        this.dialogType = 0
        this.currentFile = null
      } else if (newFile.size < FILE_SIZE_LIMIT) {
        const media = getFileTypeByName(newFile.name)
        const { type } = media
        let newType = 2
        switch (type) {
          case 'image':
            newType = 2
            break
          case 'video':
            newType = 4
            break
          case 'pdf':
            newType = 6
            break
          default:
            newType = 2
            break
        }
        this.currentFile = { ...newFile }
        this.dialogType = newType
      } else {
        this.setSnackbarNotification(
          `Max upload file size is ${FILE_SIZE_LIMIT_NAME}. Try again with smaller file.`,
        )
      }
    },
    msgHasFile(msg) {
      return !!msg.file
    },
    showBiggerImage({ url, file, name, mlResourceUrl = null, type = 1 }) {
      this.imageSrc = url
      this.imageName = name
      this.dialogFile = file
      this.dialogFileMlUrl = mlResourceUrl
      this.dialogType = type
    },
    reloadResource(url) {
      if (!url) return
      this.getResourceByUrl({ resourceUrl: url })
        .then(response => {
          const { data } = response
          if (data.fileUrl) {
            this.imageSrc = data.fileUrl
            this.imageName = data.name
            this.dialogFileMlUrl = url
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDialogImageSrc(type) {
      switch (type) {
        case 2:
          return this.currentFileSrc
        case 1:
          return this.imageSrc
        default:
          return ''
      }
    },
    closeMediaDialog() {
      this.dialogType = 0
      this.currentFile = null
      this.dialogFileMlUrl = null
      this.imageSrc = ''
      this.resourceId = null
    },
    getMoreMessages() {
      this.$emit('getMoreMessages')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

$footerMinHeight: 100px;

.chat-messages {
  position: relative;
  width: 100%;
  height: 100%;

  &__wrap {
    max-height: calc(100vh - 80px);
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  &-window {
    flex: 1;
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    background-color: $bh-white;
  }

  &-empty {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;

    &-image {
      margin: auto;
    }

    &-text {
      color: $bh-black;
      margin-bottom: 0;
    }

    &-text--subtitile {
      line-height: 1.5 * $gutter;
      font-size: 1.1429rem;
    }
  }

  // copied from bh input pill
  &-footer {
    position: relative;
    min-height: $footerMinHeight;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: $bh-white;
    display: flex;
    align-items: center;
    flex-direction: column;

    &__row {
      width: 100%;
      flex-wrap: nowrap;

      &:not(.chat-selected-message__wrap) {
        margin-top: 26px;
        margin-bottom: 26px;
      }

      & + & {
        margin-top: 0;
      }
    }
    &-send-button {
      margin-left: 5px;
      &.v-btn {
        background-color: $bh-blue;
        transition-property: box-shadow, transform, opacity, background-color;
        .v-icon {
          color: $bh-white !important;
        }
        &--disabled {
          background-color: $bh-white;
          .v-icon {
            color: $bh-gray--2 !important;
          }
        }
      }
    }
    &-input {
      margin: 0 8px !important;
      background-color: $bh-blue--4 !important;
      &.v-select {
        width: 120px;
      }

      ::v-deep {
        .v-input__slot {
          padding: 0 !important;
          border-radius: 23px;
          background-color: $bh-blue--4 !important;
        }
        .v-input__control {
        }
        .v-input__prepend-inner {
          margin-top: 0 !important;
          align-self: center !important;
        }
        textarea {
          overflow: auto;
          font-size: $gutter;
          line-height: 1.25 * $gutter;
          min-height: 1.25 * $gutter;
          height: 1.25 * $gutter;
          max-height: 5 * $gutter;
          align-self: center;
          margin: 3px 0 3px !important;
        }
      }

      .v-select__slot,
      .v-input__slot {
        align-items: center;
        min-height: 48px;
        min-height: 0 !important;

        &::before,
        &::after {
          content: '';
          display: none;
        }

        .v-input__append-inner {
          align-self: center;
          margin-top: 0 !important;
        }

        .v-icon {
          color: $bh-blue;
        }
      }
    }

    &-body {
      min-height: 46px;
      display: flex;
      align-items: center;
      width: 100%;
      position: relative;
    }

    &-body-wrapper {
      position: relative;
      width: 100%;
      background-color: $bh-blue--4;
      border-radius: 23px;
    }

    &-menu {
      height: 500px;
      max-height: 50vh;
      min-height: 100px;
      position: absolute;
      bottom: 100%;
      overflow-y: auto;
      padding: $gutter 0;
      z-index: 2;

      &-quick-message {
        color: $bh-black;
        line-height: 1.5 * $gutter;
        padding: 0.25 * $gutter $gutter;
        cursor: pointer;

        &:hover {
          background-color: $bh-gray--6;
        }
      }
    }

    &-notification {
      height: 20px;
      position: absolute;
      top: -25px;
    }
  }

  .upload-file-area {
    max-width: 48px;
    &:hover {
      ::v-deep {
        .v-btn {
          opacity: 0.7;
        }
        label {
          cursor: pointer;
        }
      }
    }
  }
  .upload-library-file {
    &::before {
      content: '';
      display: none !important;
      opacity: 0 !important;
    }
    &:hover {
      opacity: 0.7;
    }
  }
}
.chat-selected-message {
  font-size: 11px;
  line-height: 20px;
  p {
    word-break: break-all;
  }
  &__close {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
